import styled from 'styled-components';

import { Form } from 'opencare-crown';

import { BREAKPOINTS, colors } from '../../../../common/styles/style-constants';
import { PrimaryButton } from '../../../common/styled-components';

export const ContactWrapper = styled.div`
  background-color: ${colors.nickel};
  display: flex;
  width: 100%;
  flex: 1;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    padding: 0 10px 10px 10px;
  }
`;

export const Title = styled.h1`
  font-size: 42px;
  line-height: 50px;
  text-align: center;
  color: #5d7b92;
  max-width: 650px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    font-size: 32px;
    line-height: 40px;
  }
`;

export const ConciergeFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: clamp(256px, 100%, 470px);
  border-radius: 30px;
  background-color: ${colors.white};
  overflow: hidden;
`;

export const ConciergeForm = styled(Form)`
  width: 100%;
  padding: 25px !important;
  text-align: center;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    padding: 16px !important;
  }
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 60px;
  font-size: 24px;
  font-weight: bold;
  color: ${colors.white};
  background-color: #f27f6e;
  width: 100%;
  text-align: center;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    height: 48px;
  }
`;

export const Label = styled.p`
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
  color: #5d7b92;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    font-size: 14px;
    font-weight: normal;
  }
`;

export const Input = styled.input`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.gray9};
  height: auto;
  width: calc(50% - 8px);
  padding: 15px;
  margin-top: 12px;
  border-radius: 10px;
  border: 1px solid ${colors.gray6};
  word-break: normal;

  &:active,
  &:focus {
    border-color: ${colors.blue};
    box-shadow: 0 0 3px ${colors.blue};
    outline: none !important;
  }

  &:hover {
    border-color: ${colors.blue};
    box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.05);
  }

  &::placeholder {
    color: ${colors.gray6};
  }
`;

export const FormButton = styled(PrimaryButton)`
  width: 100%;
  margin-top: 20px;
  font-size: 18px;

  svg {
    margin-right: 0.25rem;
  }
`;

export const HorizontalBreak = styled.div`
  position: relative;
  margin: 15px 0;
  color: ${colors.gray7};
  text-align: center;
  font-weight: 400;

  &:before,
  &:after {
    content: '';
    display: block;
    width: 30%;
    height: 1px;
    background: ${colors.gray6};
    position: absolute;
    top: 50%;
  }

  &:before {
    left: 0;
  }
  &:after {
    right: 0;
  }
`;
